import { FormActions } from "../../components/common/FormActions";
import { TTableColumn } from "../../types/common";
import {
  CAN_EDIT_RECEIVED_INVENTORY_CHECKLIST,
  CATEGORY_INVENTORY_TYPE,
  VEHICLE_TYPE,
} from "../../utils/constants";
import { useGetConfigurableOptions } from "../../utils/formUtils";
import {
  beautify,
  createViewEdit,
  formatDate,
  itemExists,
  useGetUserPermissions,
} from "../../utils/helpers";

export const useInventory = () => {
  const getConfigOptions = () => {
    const configList = [
      { name: "vehicle_types", key: VEHICLE_TYPE },
      { name: "categories", key: CATEGORY_INVENTORY_TYPE },
    ];
    return useGetConfigurableOptions(configList);
  };
  const options = {
    ...getConfigOptions(),
  };
  const tableColumns = (): TTableColumn[] => [
    {
      id: "name",
      header: "Name",
      filter: {
        type: "text",
      },
    },
    { id: "quantity", header: "Quantity" },
    {
      id: "vehicle_type_name",
      header: "Vehicle Type",
      filter: {
        type: "select",
        key: "vehicle_type",
        options: options?.vehicle_types,
      },
    },
    {
      id: "category_name",
      header: "Category",
      filter: {
        type: "select",
        key: "category",
        options: options?.categories,
      },
    },
    {
      id: "model",
      header: "Model",
      filter: {
        type: "text",
      },
    },
    {
      id: "type_of_stock",
      header: "Type of Stock",
      filter: {
        type: "select",
        key: "type_of_stock",
        options: [
          { name: "Old Stock", id: "old_stock" },
          { name: "New Stock", id: "new_stock" },
        ],
      },
    },
    { id: "actions", header: "Actions" },
  ];

  const permissions = useGetUserPermissions();
  const canEditIventory = itemExists(permissions, [
    CAN_EDIT_RECEIVED_INVENTORY_CHECKLIST,
  ]);

  const tableData = (data: any) =>
    data.map((item: any) => ({
      ...item,
      type_of_stock: beautify(item?.type_of_stock),
      quantity: item?.quantity || "0",
      actions: (
        <FormActions
          actions={createViewEdit("/inventory", item?.id, canEditIventory)}
        />
      ),
    }));

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Inventory Information",
          fields: {
            name: item?.name,
            quantity: item?.quantity || "0",
            vehicle_type: item?.vehicle_type_name,
            category: item?.category_name,
            model: item?.model,
            type_of_stock: beautify(item?.type_of_stock),
            description: item?.description,
            specifications: item?.specifications,
            created_at: formatDate(item?.created_at),
            updated_at: formatDate(item?.updated_at),
          },
        },
      ],
    };
  };

  return { tableColumns, tableData, viewData };
};
